import axios from 'axios'
import Vue from 'vue'
import {
	baseurl
} from './url'
import {
	Toast
} from 'vant'
Vue.use(Toast)

import router from './../router'
import store from './../store'
import {
	RESET_LOAD_SHOW_LEVEL
} from "./../store/types.js";

import {
	setEssToken
} from "./cookies.js";

import {
	Tool
} from "./Tool.js";

import {
	resetRouter
} from './../router/index.js'


let msign = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL_MSIGN,
	withCredentials: false,
	headers: {
		'Content-Type': 'application/json;charset=utf-8'
	},
	timeout: 180000 // 请求超时时间
})

const seal = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL_SEAL,
	withCredentials: false,
	headers: {
		'Content-Type': 'application/json;charset=utf-8'
	},
	timeout: 180000 // 请求超时时间
})

const update = axios.create({
	baseURL: process.env.VUE_APP_UPDATE_URL,
	withCredentials: false,
	headers: {
		'Content-Type': 'application/json;charset=utf-8'
	},
	timeout: 180000 // 请求超时时间
})

// http request拦截器 添加一个请求拦截器
msign.interceptors.request.use((config) => {
	let token = window.localStorage.getItem("Identity_Token")
	if (config.baseURL === '/msign' || config.baseURL === '/sign') {
		if (token) {
			//将token放到请求头发送给服务器,将tokenkey放在请求头中
			config.headers.Authorization = 'Bearer ' + token;
			//也可以这种写法
			//config.headers['token'] = token;
		}
	}
	// else if (config.baseURL == '/seal') {
	// 	if (config.url.indexOf('/api/') != -1 || config.url.indexOf('/face/api/') != -1) {
	// 		config.headers.post['X-APP-CODE'] = 'ESIGN'
	// 		config.headers.post['X-AUTHEN-KEY'] = 'E5E867C210F845B89A8DEDCA56E45F95'
	// 	}
	// }
	//console.log('msign--------=', config, config.url, document.cookie)
	return config;
},
	function (error) {
		return Promise.reject(error);
	});

// 添加一个响应拦截器
msign.interceptors.response.use(function (response) {
	//console.log('sign-success',response)
	if (response.data.code == 500) {
		//TODO拦截没有token时，重新登录。
		//Toast("系统错误,请联系管理员");
	}
	if (response.data.code == 401) {
		window.localStorage.setItem("LoginInfo", '')
		window.localStorage.setItem("Identity_Token", '')
		store.commit("changeLoginInfo", '')
		store.commit("changeLoginToken", '')
		store.dispatch("actionUserInfo", '');
		Toast("请重新登录!");
		router.replace('/login').catch(() => {
			// 处理重定向失败的情况（例如，如果路由不存在）  
			console.error('没有找到登录页面！');
		});
		return
	}
	if (response.data.success == true) {
		return response;
	}
	return response;
}, function (error) {
	//console.log('sign-error',response)
	store.dispatch(RESET_LOAD_SHOW_LEVEL, 0)
	// 请求失败时的操作
	if (error.response) {
		console.log('response-=', error.response)
		if (error.response.status == 401) {
			window.localStorage.setItem("LoginInfo", '')
			window.localStorage.setItem("Identity_Token", '')
			store.commit("changeLoginInfo", '')
			store.commit("changeLoginToken", '')
			store.dispatch("actionUserInfo", '');
			Toast("请重新登录!");
			router.replace('/login').catch(() => {
				// 处理重定向失败的情况（例如，如果路由不存在）  
				console.error('没有找到登录页面！');
			});
		} else {
			Toast("服务器连接失败!");
		}
	} else if (error.request) {
		Toast("服务器连接失败!");
		console.log('request-=', error.request)
		// 没有收到响应
	} else {
		Toast("服务器连接失败!");
		console.log('message-=', error.message)
		// 其他错误
	}
	return Promise.reject(error);
})

seal.interceptors.request.use((config) => {
	if (config.url.indexOf('/face/api/') != -1) {
		let token = window.localStorage.getItem("Identity_Token")
		if (token) {
			//将token放到请求头发送给服务器,将tokenkey放在请求头中
			//config.headers.Authorization = token;
			//config.headers.post['token'] = token + '|' + Tool.dateFormate(new Date().getTime(),
			// 	'yyyy-MM-dd hh:mm:ss');
		}
	} else if (config.url.indexOf('/api/basic/') != -1 || config.url.indexOf('/api/doc/') != -1) {
		//config.headers.post['X-APP-CODE'] = 'ESIGN'
	}
	//config.headers.post['X-AUTHEN-KEY'] = 'E5E867C210F845B89A8DEDCA56E45F95'
	//console.log('seal/index', config)
	//console.log('seal--------=', config, config.url, document.cookie)
	return config;
}, (error) => {
	return Promise.reject(error);
})

seal.interceptors.response.use((response) => {
	//console.log('seal-response---=',response)
	if (response.data.success == true) {
		return response;
	}
	return response;
}, (error) => {
	Toast("服务器连接失败!");
	store.dispatch(RESET_LOAD_SHOW_LEVEL, 0)
	return Promise.reject(error);
})

// else if (config.url.indexOf('/seal/api/') != -1) {
// 		config.headers.post['X-APP-CODE'] = 'ESIGN'
// 		config.headers.post['X-AUTHEN-KEY'] = 'E5E867C210F845B89A8DEDCA56E45F95'
// 	} else if (config.url.indexOf('/seal/index') != -1) {
// 		config.withCredentials = true
// 		setEssToken()
// 		//config.headers.post['Cookie'] = 'ESS-TOKEN=vjLQlbWc8qDbAv5dS6NkEw=='
// 		console.log('seal/index', config)
// 	} else {
// 		console.log('else', config)
// 	}


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export const GET = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		msign.get(`${url}`, {
			params: params
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export const POST = (url, data = {}, form = 'Json', timeout) => {
	// post 默认传参方式为Json 字符串，当传参方式为Form Data 时，第三个需要参数传入 'form'
	if (form == 'form') {
		const formData = new FormData();
		for (var key in data) {
			formData.append(key, data[key]);
		}
		data = formData
	}
	//console.log('POST',data)
	return new Promise((resolve, reject) => {
		msign.post(`${url}`, data, {
			timeout: timeout
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export const POSTFILE = (url, data = {}, form = 'Json', timeout) => {
	// post 默认传参方式为Json 字符串，当传参方式为Form Data 时，第三个需要参数传入 'form'
	if (form == 'form') {
		const formData = new FormData();
		for (var key in data) {
			formData.append(key, data[key]);
		}
		data = formData
	}
	//console.log('POST',data)
	return new Promise((resolve, reject) => {
		msign.post(`${url}`, data, {
			timeout: timeout,
			headers: {
				ContentType: 'multipart/form-data',
			}
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export const SEALP = (url, data = {}, appCode, form = 'Json', timeout) => {
	// post 默认传参方式为Json 字符串，当传参方式为Form Data 时，第三个需要参数传入 'form'
	if (form == 'form') {
		const formData = new FormData();
		for (var key in data) {
			formData.append(key, data[key]);
		}
		data = formData
	}
	//console.log('POST',data)
	return new Promise((resolve, reject) => {
		seal.post(`${url}`, data, {
			headers: {
				'X-APP-CODE': appCode ? appCode : 'ESIGN',
			},
			timeout: timeout
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
// headers: {
// 	'Cookie': 'ESS-TOKEN=vjLQlbWc8qDbAv5dS6NkEw=='
// },

export const SEALG = (url, params = {}, appCode) => {
	return new Promise((resolve, reject) => {
		seal.get(`${url}`, {
			params: params,
			headers: {
				'X-APP-CODE': appCode ? appCode : 'ESIGN',
			}
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}

export const SEALPS = (url, data = {}, headers, form = 'Json', timeout) => {
	// post 默认传参方式为Json 字符串，当传参方式为Form Data 时，第三个需要参数传入 'form'
	if (form == 'form') {
		const formData = new FormData();
		for (var key in data) {
			formData.append(key, data[key]);
		}
		data = formData
	}
	//console.log('POST',data)
	return new Promise((resolve, reject) => {
		seal.post(`${url}`, data, {
			headers: {
				'X-APP-CODE': headers.appCode ? headers.appCode : 'ESIGN',
				'X-VERIFY-TOKEN': headers.verifyToken ? headers.verifyToken : '',
				'X-AUTHEN-TOKEN': headers.authenToken ? headers.authenToken : ''
			},
			timeout: timeout
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export const GETUPDATE = (url, params = {}, headers = {}) => {
	return new Promise((resolve, reject) => {
		update.get(`${url}`, {
			params: params,
			headers: headers
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}


/** 
 * get文件下载方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function GETFile(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(`${url}`, {
			params: params,
			responseType: 'blob',
		})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}


// export const GET = (url, params) => {
//     const getTimestamp = new Date().getTime();
//     return axios.get(`${base}${url}?timer=${getTimestamp}`, { params: params }).then(res => res.data)
// }